export default "__VITE_ASSET__CyD6dJih__"